// import React, { useEffect } from "react";
// import ReactStars from "react-rating-stars-component";
// import { useLocation, useNavigate } from "react-router-dom";

// import wish from "../images/wish.svg";
// // import wishlist from "../images/wishlist.svg";
// // import watch from "../images/watch.jpg";
// // import watch2 from "../images/watch-1.avif";
// // import addcart from "../images/add-cart.svg";
// import view from "../images/view.svg";
// import { useDispatch, useSelector } from "react-redux";
// import { addToWishlist } from "../features/products/productSlilce";
// import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
// import { useState } from "react";

// const ProductCard = (props) => {
//   const navigate = useNavigate();
//   const { grid, data } = props;
//   const dispatch = useDispatch();
//   console.log(data);
//   const location = useLocation();

//   const wishlistState = useSelector((state) => state?.auth?.wishlist?.wishlist);

//   const [wishlist, setWishlist] = useState(wishlistState || []);

//   useEffect(() => {
//     setWishlist(wishlistState || []);
//   }, [wishlistState]);

//   const isProductInWishlist = (productId) => {
//     return wishlist?.some((item) => item._id === productId);
//   };

//   const addToWish = (productId) => {
//     if (isProductInWishlist(productId)) {
//       dispatch(addToWishlist(productId)); // Dispatch the action to update the wishlist in Redux store

//       const updatedWishlist = wishlist.filter((item) => item._id !== productId);
//       setWishlist(updatedWishlist);
//     } else {
//       dispatch(addToWishlist(productId)); // Dispatch the action to update the wishlist in Redux store

//       const product = data.find((item) => item._id === productId);
//       setWishlist([...wishlist, product]);
//     }
//   };

//   return (
//     <>
//       {data?.map((item, index) => {
//         const isWishlist = isProductInWishlist(item._id);
//         console.log(isWishlist);
//         return (
//           <div
//             key={index}
//             className={` ${
//               location.pathname == "/product" ? `gr-${grid}` : "col-3"
//             } `}
//           >
//             <div className="product-card position-relative">
//               <div className="wishlist-icon position-absolute">
//                 <button
//                   className="border-0 bg-transparent"
//                   onClick={(e) => addToWish(item?._id)}
//                 >
//                   {isWishlist ? (
//                     <AiFillHeart className="fs-5 me-1" />
//                   ) : (
//                     <AiOutlineHeart className="fs-5 me-1" />
//                   )}
//                 </button>
//               </div>

//               <div className="product-image">
//                 {/* <img
//                   src={item?.images[0]?.url}
//                   // className="img-fluid d"
//                   alt="product image"
//                   height={"250px"}
//                   width={"100%"}
//                   onClick={() => navigate("/product/" + item?._id)}
//                 />
//                 <img
//                   src={item?.images[0]?.url}
//                   // className="img-fluid d"
//                   alt="product image"
//                   height={"250px"}
//                   width={"100%"}
//                   onClick={() => navigate("/product/" + item?._id)}
//                 /> */}
//               </div>
//               <div className="product-details">
//                 <h6 className="brand">{item?.brand}</h6>
//                 <h5 className="product-title">
//                   {grid === 12 || grid === 6
//                     ? item?.title
//                     : item?.title?.substr(0, 80) + "..."}
//                 </h5>
//                 <ReactStars
//                   count={5}
//                   size={24}
//                   value={item?.totalrating}
//                   edit={false}
//                   activeColor="#ffd700"
//                 />

//                 <p className="price">Rs.{item?.price}</p>
//               </div>
//               <div className="action-bar position-absolute">
//                 <div className="d-flex flex-column gap-15">
//                   {/* <button className="border-0 bg-transparent">
//                     <img src={prodcompare} alt="compare" />
//                   </button> */}

//                   {/* <button className="border-0 bg-transparent">
//                     <img
//                       onClick={() => navigate("/product/" + item?._id)}
//                       src={view}
//                       alt="view"
//                     />
//                   </button> */}
//                   {/* <button className="border-0 bg-transparent">
//                     <img src={addcart} alt="addcart" />
//                   </button> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         );
//       })}
//     </>
//   );
// };

// export default ProductCard;

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist } from "../features/products/productSlilce";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import ReactStars from "react-rating-stars-component";

const ProductCard = ({ grid, data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const wishlistState = useSelector((state) => state?.auth?.wishlist?.wishlist);
  const [wishlist, setWishlist] = useState(wishlistState || []);

  useEffect(() => {
    setWishlist(wishlistState || []);
  }, [wishlistState]);

  const isProductInWishlist = (productId) => wishlist?.some((item) => item._id === productId);

  const handleWishlistToggle = (productId) => {
    dispatch(addToWishlist(productId));

    setWishlist((prev) =>
      isProductInWishlist(productId)
        ? prev.filter((item) => item._id !== productId)
        : [...prev, data.find((item) => item._id === productId)]
    );
  };

  return (
    <>
      {data?.map((item, index) => {
        const isWishlist = isProductInWishlist(item._id);

        return (
          <div
            key={index}
            className={`${
              location.pathname === "/product" ? `gr-${grid}` : ""
            }`}
          >
            <div className="relative p-8 border rounded-lg shadow-md bg-white">
               {/* Wishlist Icon */}
              <button
                className="absolute top-2 right-2 text-red-500"
                onClick={() => handleWishlistToggle(item?._id)}
              >
                {isWishlist ? <AiFillHeart size={20} /> : <AiOutlineHeart size={20} />}
              </button>

              {/* Product Image */}
              <div
                className="cursor-pointer h-64 w-64"
                onClick={() => navigate("/product/" + item?._id)}
              >
                <img
                  src={item?.images?.[0]?.url || "https://via.placeholder.com/250"}
                  alt="product"
                  className="w-full h-full object-cover rounded"
                />
              </div>

              {/* Product Details */}
              <div className="mt-3">
                <h6 className="text-gray-500">{item?.brand || "Demo Brand"}</h6>
                <h5 className="font-semibold">
                  {grid === 12 || grid === 6
                    ? item?.title
                    : (item?.title || "Demo Product").substring(0, 80) + "..."}
                </h5>
                <ReactStars
                  count={5}
                  size={24}
                  value={item?.totalrating || 4}
                  edit={false}
                  activeColor="#ffd700"
                />
                <p className="text-lg font-bold">Rs. {item?.price || "999"}</p>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ProductCard;

  